<template>

  <div class="card mb-3  mt-1 rounded-10 w-100" :class="cardClassColor">
    <div class="card-body">
      <div class="row">
        <div class="col-auto">
          <div class="card shadow-none border" :class="bgClassColor">
            <div class="card-body p-0">
              <div class="avatar avatar-50 rounded-6">
                <slot name="customAlertIcon"></slot>
              </div>
            </div>
          </div>
        </div>
        <div class="col align-self-center ps-0">
          <slot name="customAlertText"></slot>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
export default {
  name: "BaseCustomAlert",
  props : ['cardClassColor', 'bgClassColor']
}
</script>



<style scoped>

</style>